export default "__VITE_ASSET__D8PO1KaW__"